/* Irish Riviera Golf — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  /* --- Mobile Menu --- */
  const toggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('is-open');
      mobileNav.setAttribute('aria-hidden', !isOpen);
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* --- Product Gallery Thumbnails --- */
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.getElementById('main-product-image');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = this.dataset.src;
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* --- Color Swatches (Product Page) --- */
  const swatches = document.querySelectorAll('.product-form__swatches .swatch');
  const variantInput = document.getElementById('variant-id');
  const selectedColorLabel = document.getElementById('selected-color');
  const priceEl = document.getElementById('product-price');
  const addToCartBtn = document.getElementById('add-to-cart');

  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      swatches.forEach(function (s) { s.classList.remove('swatch--selected'); });
      this.classList.add('swatch--selected');
      if (variantInput) variantInput.value = this.dataset.variantId;
      if (selectedColorLabel) selectedColorLabel.textContent = this.dataset.value;
      if (this.dataset.unavailable && addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold Out';
      } else if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to Cart';
      }
    });
  });

  /* --- Quantity Selector --- */
  const qtyInput = document.getElementById('quantity');
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus = document.getElementById('qty-plus');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      const v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  /* --- Add to Cart (AJAX) --- */
  const productForm = document.getElementById('product-form');
  const cartNotice = document.getElementById('cart-notice');
  const cartCount = document.getElementById('cart-count');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(productForm);
      const data = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (cartNotice) cartNotice.style.display = 'block';
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cartCount) cartCount.textContent = cart.item_count;
      })
      .catch(function (err) { console.error('Add to cart error:', err); });
    });
  }

});
